import Fetch, { V1 } from 'Util/fetcher';

//= =======================================================================================//
//                                          GET FAQ CATEGORY                               //
//= =======================================================================================//

const ON_REQUEST_CATEGORY = 'ON_REQUEST_CATEGORY';
const ON_REQUEST_CATEGORY_SUCCESS = 'ON_REQUEST_CATEGORY_SUCCESS';
const ON_REQUEST_CATEGORY_FAILURE = 'ON_REQUEST_CATEGORY_FAILURE';

function onRequestCategoryFAQ() {
  return {
    type: ON_REQUEST_CATEGORY,
  };
}

function onRequestCategoryFAQSuccess(payload) {
  return {
    type: ON_REQUEST_CATEGORY_SUCCESS,
    payload,
  };
}

function onRequestCategoryFAQFailure(payload) {
  return {
    type: ON_REQUEST_CATEGORY_FAILURE,
    payload,
  };
}

export const onDoRequestCategoryFAQ = () => (dispatch) => {
  dispatch(onRequestCategoryFAQ());
  Fetch.get(`${V1}faq/group/`)
    .then((resp) => {
      if (resp.ok) {
        //TODO: Should filter from BE side
        const filteredFaq = resp.json.length && resp.json.filter((faq) => faq.code !== 'ASET_KRIPTO') 
        dispatch(onRequestCategoryFAQSuccess(filteredFaq));
      } else {
        dispatch(onRequestCategoryFAQFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestCategoryFAQFailure(error.message));
    });
};

//= =======================================================================================//
//                                              GET FAQ List                               //
//= =======================================================================================//

const ON_REQUEST_FAQ_LIST = 'ON_REQUEST_FAQ_LIST';
const ON_REQUEST_FAQ_LIST_SUCCESS = 'ON_REQUEST_FAQ_LIST_SUCCESS';
const ON_REQUEST_FAQ_LIST_FAILURE = 'ON_REQUEST_FAQ_LIST_FAILURE';

function onRequestFaqList(resetData) {
  return {
    type: ON_REQUEST_FAQ_LIST,
    meta: { resetData },
  };
}

function onRequestFaqListSuccess(payload) {
  return {
    type: ON_REQUEST_FAQ_LIST_SUCCESS,
    payload,
  };
}

function onRequestFaqListFailure(payload) {
  return {
    type: ON_REQUEST_FAQ_LIST_FAILURE,
    payload,
  };
}

export const onDoRequestFaqList = (payload, resetData = false) => (
  dispatch
) => {
  dispatch(onRequestFaqList(resetData));
  Fetch.get(`${V1}faq/custom/${payload}`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestFaqListSuccess(resp.json));
      } else {
        dispatch(onRequestFaqListFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestFaqListFailure(error.message));
    });
};

//= =======================================================================================//
//                                              Save Detail                                //
//= =======================================================================================//

const ON_SAVE_DETAIL = 'ON_SAVE_DETAIL';

function onSaveDetail(payload) {
  return {
    type: ON_SAVE_DETAIL,
    payload,
  };
}
export const onDoSaveDetail = payload => (dispatch) => {
  dispatch(onSaveDetail(payload));
};

//= =======================================================================================//
//                                              GET FAQ List By Group                      //
//= =======================================================================================//

const ON_REQUEST_FAQ_LIST_BY_GROUP = 'ON_REQUEST_FAQ_LIST_BY_GROUP';
const ON_REQUEST_FAQ_LIST_BY_GROUP_SUCCESS = 'ON_REQUEST_FAQ_LIST_BY_GROUP_SUCCESS';
const ON_REQUEST_FAQ_LIST_BY_GROUP_FAILURE = 'ON_REQUEST_FAQ_LIST_BY_GROUP_FAILURE';

function onRequestFaqListByGroup(resetData) {
  return {
    type: ON_REQUEST_FAQ_LIST_BY_GROUP,
    meta: { resetData },
  };
}

function onRequestFaqListByGroupSuccess(payload) {
  return {
    type: ON_REQUEST_FAQ_LIST_BY_GROUP_SUCCESS,
    payload,
  };
}

function onRequestFaqListByGroupFailure(payload) {
  return {
    type: ON_REQUEST_FAQ_LIST_BY_GROUP_FAILURE,
    payload,
  };
}

export const onDoRequestFaqListByGroup = (groupId, resetData = false) => (
  dispatch
) => {
  dispatch(onRequestFaqListByGroup(resetData));
  Fetch.get(`${V1}faq/group/${groupId}/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestFaqListByGroupSuccess(resp.json));
      } else {
        dispatch(onRequestFaqListByGroupFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestFaqListByGroupFailure(error.message));
    });
};

// FAQ BY GROUP CODE

const ON_REQUEST_FAQ_BY_GROUP_CODE = 'ON_REQUEST_FAQ_LIST_BY_GROUP';
const ON_REQUEST_FAQ_BY_GROUP_CODE_SUCCESS = 'ON_REQUEST_FAQ_BY_GROUP_CODE_SUCCESS';
const ON_REQUEST_FAQ_BY_GROUP_CODE_FAILURE = 'ON_REQUEST_FAQ_BY_GROUP_CODE_FAILURE';

function onRequestFaqByGroupCode(resetData) {
  return {
    type: ON_REQUEST_FAQ_BY_GROUP_CODE,
    meta: { resetData },
  };
}

function onRequestFaqByGroupCodeSuccess(payload) {
  return {
    type: ON_REQUEST_FAQ_BY_GROUP_CODE_SUCCESS,
    payload,
  };
}

function onRequestFaqByGroupCodeFailure(payload) {
  return {
    type: ON_REQUEST_FAQ_BY_GROUP_CODE_FAILURE,
    payload,
  };
}

export const onDoRequestFaqByGroupCode = (groupCode, resetData = false) => (
  dispatch
) => {
  dispatch(onRequestFaqByGroupCode(resetData));
  Fetch.get(`${V1}faq/group/code/${groupCode}/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestFaqByGroupCodeSuccess(resp.json));
      } else {
        dispatch(onRequestFaqByGroupCodeFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestFaqByGroupCodeFailure(error.message));
    });
};

const INITIAL_STATE = {
  faqCategoryLoading: null,
  faqCategoryList: null,
  faqCategoryError: null,

  faqListLoading: null,
  faqListData: null,
  faqListerror: null,

  faqListByGroupLoading: null,
  faqListByGroupData: null,
  faqListByGroupError: null,

  faqListByGroupCodeLoading: null,
  faqListByGroupCodeData: null,
  faqListByGroupCodeError: null,

  detailFAQ: null,
};

const faq = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case ON_REQUEST_CATEGORY:
      return {
        ...state,
        faqCategoryLoading: true,
        faqCategoryList: null,
        faqCategoryError: null,
      };
    case ON_REQUEST_CATEGORY_SUCCESS:
      return {
        ...state,
        faqCategoryLoading: false,
        faqCategoryList: action.payload,
        faqCategoryError: null,
      };
    case ON_REQUEST_CATEGORY_FAILURE:
      return {
        ...state,
        faqCategoryLoading: false,
        faqCategoryError: action.payload,
      };

    case ON_REQUEST_FAQ_LIST:
      return {
        ...state,
        faqListLoading: true,
        faqListData: null,
        faqListError: null,
      };

    case ON_REQUEST_FAQ_LIST_SUCCESS:
      return {
        ...state,
        faqListLoading: false,
        faqListData: action.payload,
        faqListError: null,
      };
    case ON_REQUEST_FAQ_LIST_FAILURE:
      return {
        ...state,
        faqListLoading: false,
        faqListError: action.payload,
      };
    // FAQ LIST BY GROUP
    case ON_REQUEST_FAQ_LIST_BY_GROUP:
      return {
        ...state,
        faqListByGroupLoading: true,
        faqListByGroupData: null,
        faqListByGroupError: null,
      };
    case ON_REQUEST_FAQ_LIST_BY_GROUP_SUCCESS:
      return {
        ...state,
        faqListByGroupLoading: false,
        faqListByGroupData: action.payload,
        faqListByGroupError: null,
      };
    case ON_REQUEST_FAQ_LIST_BY_GROUP_FAILURE:
      return {
        ...state,
        faqListByGroupLoading: false,
        faqListByGroupError: action.payload,
      };
    // FAQ BY GROUP CODE
    case ON_REQUEST_FAQ_BY_GROUP_CODE:
      return {
        ...state,
        faqListByGroupCodeLoading: true,
        faqListByGroupCodeData: null,
        faqListByGroupCodeError: null,
      };
    case ON_REQUEST_FAQ_BY_GROUP_CODE_SUCCESS:
      return {
        ...state,
        faqListByGroupCodeLoading: false,
        faqListByGroupCodeData: action.payload,
        faqListByGroupCodeError: null,
      };
    case ON_REQUEST_FAQ_BY_GROUP_CODE_FAILURE:
      return {
        ...state,
        faqListByGroupCodeLoading: false,
        faqListByGroupCodeError: action.payload,
      };
    case ON_SAVE_DETAIL:
      return {
        ...state,
        detailFAQ: action.payload,
      };
    default:
      return state;
  }
};

export default faq;
